module.exports = __webpack_public_path__ + "assets/mastercard-a16e3a.svg";